import { Card, CardContent } from '@up2stay/up2promo-ui';
import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

/** Profiles SoT section title (`--t-h3`) for Team detail cards. */
export const TEAM_DETAIL_SECTION_TITLE_CLASS =
  'text-[15.5px] font-bold leading-tight text-foreground';

/** Profiles SoT body (`--t-body`). */
export const TEAM_DETAIL_BODY_CLASS =
  'text-[13.5px] leading-relaxed text-foreground';

/** Profiles SoT muted body. */
export const TEAM_DETAIL_MUTED_CLASS =
  'text-[13.5px] leading-relaxed text-muted-foreground';

/** Profiles SoT label (`--t-label`). */
export const TEAM_DETAIL_LABEL_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.6px] text-muted-foreground';

type TeamDetailSectionCardProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

/**
 * Shared Team-detail section shell — Card + Profiles density (`p-5 sm:p-6`).
 */
export function TeamDetailSectionCard({
  children,
  className,
  contentClassName,
}: TeamDetailSectionCardProps) {
  return (
    <Card className={cn('min-w-0 overflow-hidden', className)}>
      <CardContent
        className={cn('flex flex-col gap-3 p-5 sm:p-6', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
